import { createSlice, createAction, PayloadAction } from '@reduxjs/toolkit'
import { ApiError, RequestStatus } from 'features/common'

const name = 'developers'
const UPDATES_FETCH_REQUEST = `${name}/fetch_updates_request`

export interface DevelopersState {
  updatesMarkdown: string
  updatesStatus: RequestStatus
  updatesError?: ApiError | null
}

const initialState: DevelopersState = {
  updatesMarkdown: '',
  updatesStatus: RequestStatus.Idle
}

const asyncActions = {
  updatesRequest: createAction(UPDATES_FETCH_REQUEST)
}

const reducers = {
  addUpdates: (state: DevelopersState, action: PayloadAction<string>) => {
    state.updatesMarkdown = action.payload
  },
  setUpdatesStatus: (state: DevelopersState, action: PayloadAction<RequestStatus>) => {
    state.updatesStatus = action.payload
  },
  setUpdatesError: (state: DevelopersState, action: PayloadAction<ApiError>) => {
    state.updatesError = action.payload
  }
}

export const developersSlice = createSlice({
  name,
  initialState,
  reducers
})

export const { addUpdates, setUpdatesStatus, setUpdatesError } = developersSlice.actions

export const { updatesRequest } = asyncActions

export default developersSlice.reducer
